<template>
  <b-row v-if="parentPath && path" style="height:100%;">
    <b-col md="12">
      <b-card :header="uniTranslation('S954')" class="bottom-card card-panel" style="height:100%;">
        <div class="row">
          <div class="col-12">
            <div v-show="showFull == false">
              <kendo-grid
                :data-source="localWarnings"
                :selectable="'multiple row'"
                :columns="columns"
                :sortable="true"
                :filterable="false"
                :groupable="false"
                :allow-copy="true"
              >
              </kendo-grid>
            </div>
            <div v-show="showFull == true">
              <kendo-grid
                :data-source="localWarnings"
                :selectable="'multiple row'"
                :columns="columnsFull"
                :sortable="true"
                :filterable="false"
                :groupable="false"
                :allow-copy="true"
              >
              </kendo-grid>
            </div>
          </div>
          <!-- <div class="col-xl-6 col-lg-12"> -->
          <!-- :toolbar="['excel']"
                    :excel-file-name="'Warnings.xlsx'"
                    :excel-proxy-URL="'https://demos.telerik.com/kendo-ui/service/export'"
                    :excel-filterable="true" -->
        </div>
        <!-- <div class="row">
          <div class="col-12">
            <el-checkbox v-model="showFull"> Show Full </el-checkbox>
          </div>
        </div> -->
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
// import UnidataEditor from "../unidata/UnidataEditor";
import { mapGetters } from "vuex";
// import { Select, Option, Collapse, CollapseItem, Checkbox } from "element-ui";
// import jsonHelper from "../../shared/jsonHelper";

import "@progress/kendo-ui";
// import { Grid } from "@progress/kendo-grid-vue-wrapper"; // GridInstaller

export default {
  components: {
    /*UnidataEditor,
    "el-select": Select,
    "el-option": Option,
    "el-collapse": Collapse,
    "el-collapse-item": CollapseItem,
    "el-checkbox": Checkbox,
    Grid*/
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    },
    warnings: {
      required: true
    },
  },
  data() {
    return {
      path: null,
      showFull: false
    };
  },
  computed: {
    ...mapGetters(["projects"]),
    localWarnings: function() {
      var that = this;
      var localWarnings = [];
      if (that.warnings !== undefined && that.warnings !== null) {
        that.warnings.forEach(element => {
          let bShow = element.valid && element.showWarning;
          let message = that.uniTranslation(element.message);
          let condition = that.uniTranslation(element.condition);

          if (element.variables != null && element.variables.length > 0) {
            //sostituzione per $$

            condition = condition.replace("$$", element.variables[0]);
            message = message.replace("$$", element.variables[0]);
            //----------------------
            let i = 0;
            element.variables.forEach(function(variable) {
              condition = condition.replace("{" + i + "}", variable);
              message = message.replace("{" + i + "}", variable);
              i += 1;
            });
          }

          if (bShow) {
            localWarnings.push({
              message: message,
              condition: condition,
              variables: JSON.stringify(element.variables),
              phase: element.phase,
              valid: element.valid,
              showWarning: element.showWarning,
              level: that.getLevel(element.level)
            });
          }
        });
      }
      return localWarnings;
    },
    columns: function() {
      var that = this;
      return [
        { field: "message", width: "65%", title: that.uniTranslation("S264") },
        { field: "condition", width: "35%", title: that.uniTranslation("S1466") }
      ];
    },
    columnsFull: function() {
      var that = this;
      return [
        { field: "phase", width: "5%", title: "Phase" },
        { field: "valid", width: "10%", title: "Valid" },
        { field: "showWarning", width: "10%", title: "Show" },
        { field: "message", width: "40%", title: that.uniTranslation("S264") },
        { field: "condition", width: "20%", title: that.uniTranslation("S1466") },
        { field: "variables", width: "10%", title: "Variables" },
        { field: "level", width: "5%", title: "Level" }
      ];
    }
  },
  watch: {
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    }
  },
  mounted: function() {
    if (this.parentPath && this.localPath) this.path = this.parentPath + this.localPath;
    // var that = this;
  },
  methods: {
    subViewToggle(subView) {
      this.$store.dispatch(subView);
    },
    getLevel(level) {
      if (level == 1) return "Low";
      if (level == 2) return "Medium";
      if (level == 3) return "High";
    }
  }
};
</script>

<style lang="scss"></style>

<!-- 
/* use it only for testing */
      localDataSource: [{
                "ProductID": 1,
                "ProductName": "Chai",
                "UnitPrice": 18,
                "UnitsInStock": 39,
                "Discontinued": false,
            },
            {
                "ProductID": 2,
                "ProductName": "Chang",
                "UnitPrice": 17,
                "UnitsInStock": 40,
                "Discontinued": false,
            },
            {
                "ProductID": 3,
                "ProductName": "Aniseed Syrup",
                "UnitPrice": 10,
                "UnitsInStock": 13,
                "Discontinued": false,
            }
        ],
-->
